<template>
  <div class='h-outTabs'>
    <div id='serviceProfileTable' class='h100vh-140'>
      <ServiceProfileMenu @methodEnum='methodEnum'></ServiceProfileMenu>
      <ServiceProfileTable ref="serviceProfileTable"></ServiceProfileTable>
    </div>
  </div>
</template>
<script>
import ServiceProfileMenu from './ServiceProfileMenu';
import ServiceProfileTable from './ServiceProfileTable';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'ServiceProfileList',
  components: {
    ServiceProfileMenu,
    ServiceProfileTable
  },
  data() {
    return {
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          this.$refs.serviceProfileTable.page.pageNo = "1";
          this.$refs.serviceProfileTable.getServiceProfileListData();
          break;
        case 'add':
          this.$refs.serviceProfileTable.addServiceProfilePage();
          break;      
        case 'delete':
          this.$refs.serviceProfileTable.deleteServiceProfilePage();
          break;      
        case 'instance':
          this.$refs.serviceProfileTable.instanceServiceProfilePage();
          break;      
        default:
      }
    }
  },
  mounted() {
  }
};
</script>
